<!-- 嵌入式-数据集设置 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onAddSet()">
        <i class="fas fa-plus"></i> 新增数据集
      </el-button>
      <div class="former">
        <el-input
          clearable
          v-model="form['Name|Taxo:like']"
          placeholder="数据集名称或编号"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      size="medium"
      :data="itemList"
      v-loading="loading"
      empty-text="未添加数据集">
      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <el-table
            size="medium"
            v-loading="loading"
            :data="row.Streams"
            empty-text="未添加数据流">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="Name" label="数据流名称"></el-table-column>
            <el-table-column prop="Keypath" label="数据流路径"></el-table-column>
            <el-table-column prop="Type" label="类型">
              <template slot-scope="{ row }">
                {{ typeList.find(e=> e.key === row.Type)
                && typeList.find(e=> e.key === row.Type).value }}
              </template>
            </el-table-column>
            <el-table-column prop="Priority" label="优先级"></el-table-column>
            <el-table-column prop="Exhibited" label="是否显示">
              <template slot-scope="{ row }">
                {{ row.Exhibited ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column width="120" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" title="编辑" @click="onEditStream(scope.row)">
                  <i class="fas fa-edit"></i>
                </el-button>
                <el-button type="danger" title="删除" @click="onDeleteStream(scope.row)">
                  <i class="fas fa-trash"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <!-- <el-table-column type="index" :index="pager.size * (pager.page - 1) + 1">
      </el-table-column> -->
      <el-table-column prop="Name" label="数据集名称"></el-table-column>
      <el-table-column prop="Taxo" label="数据集编号"></el-table-column>
      <el-table-column label="数据流数量">
        <template slot-scope="{ row }">
          {{ row.Streams && row.Streams.length }}
        </template>
      </el-table-column>
      <el-table-column width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="success" title="新增数据流" @click="onAddStream(scope.row)">
              <i class="fas fa-plus"></i>
            </el-button>
            <el-button type="primary" title="编辑" @click="onEditSet(scope.row)">
              <i class="fas fa-pencil-alt"></i>
            </el-button>
            <el-button type="danger" title="删除" @click="onDeleteSet(scope.row)">
              <i class="fas fa-trash-alt"></i>
            </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form v-model="item" :visible.sync="itemVisible" @form:saved="getItemList" />
    <item-detail v-model="streamItem" :visible.sync="streamVisible" @form:saved="getItemList" />
  </el-card>
</template>

<script>
import ItemForm from './index--form.vue';
import ItemDetail from './detail--form.vue';

export default {
  components: {
    ItemForm,
    ItemDetail,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        'Name:like': '',
      },
      item: this.getEmptyItem(),
      itemVisible: false,

      streamItem: this.getEmptyStream(),
      streamVisible: false,

      typeList: [
        { key: 'text', value: '文本' },
        { key: 'float', value: '数字' },
        { key: 'enum', value: '枚举' },
        { key: 'bool', value: '布尔' },
      ],
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get('category', {
          params: {
            where: this.form,
            with: ['Streams'],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // item置空
    getEmptyItem() {
      return {
        Name: '',
        Taxo: '',
        Priority: 0,
        ShowTime: true,
      };
    },
    getEmptyStream() {
      return {
        CategoryID: '',
        Name: '', // 数据流名称
        Keypath: '', // 数据流路径
        Type: 'text', // 数据类型 // 默认文本
        Options: [], // 候选项
        Priority: 0, // 优先级
        Exhibited: true, // 是否显示
        Template: '', // 显示模板
      };
    },
    // 新增数据集
    onAddSet() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    // 编辑数据集
    onEditSet(row) {
      this.item = { ...row };
      this.itemVisible = true;
    },
    // 删除数据集
    onDeleteSet(row) {
      this.$confirm('请确认是否将数据集删除?', '删除数据集')
        .then(() => this.$axios.delete(`category/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success('数据集删除成功');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增数据流
    onAddStream(row) {
      this.streamItem = this.getEmptyStream();
      this.streamItem.CategoryID = row.ID;
      this.streamVisible = true;
    },
    // 编辑数据流
    onEditStream(row) {
      this.streamItem = { ...row };
      this.streamVisible = true;
    },
    // 删除数据流
    onDeleteStream(row) {
      this.$confirm('请确认是否将数据流删除?', '删除数据流')
        .then(() => this.$axios.delete(`category/stream/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success('数据流删除成功');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
